// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2567":"f845be0d","5445":"b9efea02","6488":"4826d724"}[chunkId] + ".chunk.css";
};